<template>
  <div>
    <input
      class="full search_field"
      @focus="is_searching=true"
      @blur="is_searching=false"
      @input="search"
      type="text"
      placeholder="Search Applicants / Companies"
    />
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'search-box',
  data () {
    return {
      is_searching: false
    }
  },
  computed: {
    ...mapGetters('modals', ['isModalOpen', 'findModal'])
  },
  methods: {
    search (event) {
      let modal = this.findModal({ type: 'designator', value: 'search-modal' })
      let keyword = event.target.value
      if (keyword.length == 0) {
        this.is_searching = false
        this.removeModal(modal)
        return
      }
      if (this.isModalOpen({ type: 'designator', value: 'search-modal' })) {
        modal.keyword = keyword
        this.updateModal(modal)
        return
      }
      this.createModal({ designator: 'search-modal', component_name: 'SearchForm', keyword: keyword, modal_title: 'Search' })
    },
    ...mapMutations('modals', ['createModal', 'updateModal', 'removeModal'])
  }
}
</script>
<style scoped>
  .search_field {
    background-color: transparent !important;
    color: white;
    position: relative;
    width: 240px;
    transition: all 0.2s;
  }
  .search_field_z_index {
    z-index: 10000000;
  }
  .is_searching {
    background-color: white !important;
    color: var(--color-text) !important;
  }
</style>
